// @ts-nocheck
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import basePageModule from "@insite/content-library/Pages/Page";
import Page from "@insite/mobius/Page";
import StretchLayout from "@store/Library/Components/Toolkit/Layout/StretchLayout";
import cloneDeep from "lodash/cloneDeep";
import React, { FC } from "react";

const StretchPage: FC<PageProps> = ({ id }) => (
    <Page>
        <StretchLayout id={id} />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    ...cloneDeep(basePageModule),
    component: StretchPage,
};

export default pageModule;
